import { Routes, Route, Navigate } from "react-router-dom";
import { mobileRoutes } from "routes";
import useDeviceStore from "store/DeviceStore";

const Root = () => {

  const { device } = useDeviceStore();
  return (
    <div className={device !== 'pc' ? "app" : "app app_pc"}>
      {
        device !== 'pc' ? 
        <Routes>
        {mobileRoutes.map(({ path, Component }, count) => (
          <Route
            key={count}
            path={path}
            element={Component ? <Component /> : <></>}
          />
        ))}
        <Route path="/method" element={<Navigate to="/qrpay" replace />} />
      </Routes> :
      <Routes>
      {mobileRoutes.map(({ path, Component }, count) => (
        <Route
          key={count}
          path={path}
          element={Component ? <Component /> : <></>}
        />
      ))}
      <Route path="/method" element={<Navigate to="/qrpay" replace />} />
    </Routes>
      }
      
    </div>
  );
};

export default Root;
